import styled from "styled-components";

import { CopyableCode } from "_/components/copyable-code";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
`;

export const Link = styled(CopyableCode)`
  word-break: break-all;
  font-size: 0.875rem;
  background-color: ${(p) => p.theme.background.primary};
  border: 1px solid ${(p) => p.theme.background.tertiary};
`;

export const Footnote = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.secondary};
`;
